var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable no-restricted-globals */
import { useSnackbar } from "@gemini/ui";
import { useI18n } from "@/shared/hooks";
import { useHardFactsTitle } from "@/contexts/classified";
import { IS_SERVER } from "@/constants";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const useShare = () => {
    const { t } = useI18n();
    const { add } = useSnackbar();
    const { title } = useHardFactsTitle();
    const isPreviewMode = useIsPreviewMode();
    if (IS_SERVER)
        return {
            copyShare: () => undefined,
            nativeMobileShare: () => undefined,
        };
    const copyShare = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (IS_SERVER || isPreviewMode)
            return;
        const shareUrl = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin) + ((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.pathname);
        try {
            yield window.navigator.clipboard.writeText(shareUrl);
            add({
                description: t("common.CTA.copyShare.success"),
                variant: "success",
            });
        }
        catch (_c) {
            add({
                description: t("common.CTA.copyShare.error"),
                variant: "error",
            });
        }
    });
    const nativeMobileShare = () => {
        var _a, _b;
        if (IS_SERVER || isPreviewMode)
            return;
        const shareUrl = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin) + ((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.pathname);
        const shareData = {
            url: shareUrl,
            text: t("common.CTA.nativeShare.text"),
            title,
        };
        if ((window === null || window === void 0 ? void 0 : window.navigator["share"]) && (window === null || window === void 0 ? void 0 : window.navigator.canShare(shareData))) {
            window.navigator.share(shareData);
        }
        else {
            add({
                description: t("common.CTA.nativeShare.error"),
                variant: "error",
            });
        }
    };
    return {
        copyShare,
        nativeMobileShare,
    };
};
